import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { PerformanceOverviewComponent } from './components/performance-overview/performance-overview.component';
import { TopProductsCardComponent } from './components/top-products-card/top-products-card.component';
import { CategoryBreakdownComponent } from './components/category-breakdown/category-breakdown.component';
import { HourlyChartComponent } from './components/hourly-chart/hourly-chart.component';
import { InsightsCardComponent } from './components/insights-card/insights-card.component';
import { PlanFeatureService } from 'src/app/services/plan-feature.service';
import { FEATURES } from 'src/app/shared/config/plan-features';

@Component({
  selector: 'app-stats-view',
  imports: [
    PerformanceOverviewComponent,
    TopProductsCardComponent,
    CategoryBreakdownComponent,
    HourlyChartComponent,
    InsightsCardComponent,
    RouterModule,
  ],
  templateUrl: './stats-view.component.html',
  styleUrls: ['./stats-view.component.css'],
})
export class StatsViewComponent {
  readonly planFeatureService = inject(PlanFeatureService);
  readonly FEATURES = FEATURES;
}
